import React, { useState, useEffect, useRef } from 'react';
import CellImg from '../assets/images/Dimond.png';
import BoombGif from '../assets/images/stockBlast.gif';
import Boomb from '../assets/images/Bomb.png';
import $ from 'jquery';

interface BoardProps {
  size: number;
  numBombs: number;
  isRandomSelect: boolean;
  isCashout: boolean;
  gameData: any;
  setBetData: (betData: any) => void;
  setAutoRounds: (autoRounds: any) => void;
  betType: any;
  isAutoCall:boolean
}

interface GridCell {
  cell: number;
}

const Board: React.FC<BoardProps> = ({ size, numBombs, isRandomSelect, isCashout, gameData, setBetData, setAutoRounds, betType, isAutoCall }) => {
  const [gridCell, setGridCell] = useState<GridCell[]>([]);
  const [gameCellData, setGameCellData] = useState(gameData);
  const [autoRoundActive, setAutoRoundActive] = useState<number[]>([]);

  useEffect(() => {
    // console.log(gameData)
    setGameCellData(gameData);   
  }, [gameData]);

  useEffect(() => {
    // console.log(gameData)
    setAutoRoundActive([]);
  }, [betType]);

  useEffect(() => {
    if (isRandomSelect) {
      while (true) {
        let cellNo = Math.floor(Math.random() * (size * size)) + 1;
        if (gameCellData?.state?.rounds.indexOf(cellNo) === -1) {
          handleCellClick(cellNo); 
          break;
        }
      }
    }
  }, [isRandomSelect]);


  const handleCellClick = (cellNumber: number) => {   
    if (betType === 'manual') {
      if (gameCellData?.state?.rounds.indexOf(cellNumber) === -1) {
        setBetData({ field: cellNumber });       
      }
      
    } else {
      //console.log(size, numBombs)

      setAutoRoundActive((prevArray): any => {
        // If the value already exists, remove it. Otherwise, add it.
        if (prevArray.includes(cellNumber)) {
          return prevArray.filter((item) => item !== cellNumber); // Remove the value
        } else {

          if (autoRoundActive?.length < size * size - numBombs) {
            return [...prevArray, cellNumber]; // Add the value
          }
          return prevArray;
        }
      });

    }

  };

  useEffect(() => {
    setAutoRounds(autoRoundActive);
    //console.log(autoRoundActive)
  }, [autoRoundActive]);

  useEffect(() => {
    let cell = 1;
    const cellData = Array(size * size)
      .fill(null).map(() => ({
        cell: cell++,
      }));
    setGridCell(cellData);
    setAutoRoundActive([]);
    setAutoRounds([]);
    if(betType==='auto' && isAutoCall){
      setGameCellData({});
    }
    
  }, [size, numBombs]);


  const getCellContent = (cellNumber: number) => {   
    switch (true) {
      case (gameCellData?.minesNext?.active === 1 && gameCellData?.state?.rounds.indexOf(cellNumber) > -1):
        return (
          <div className="cellImg">
            <div className="mainDimond">
              <img src={CellImg} alt="Cell" className="img-fluid dimond rotate" />
            </div>
          </div>
        )

      case (gameCellData?.minesNext?.active === 0):
        switch (true) {
          case (gameCellData?.state?.mines && gameCellData?.state?.mines.indexOf(cellNumber) > -1):
            return (
              <div className="bombMain">
                <img src={BoombGif} alt="Bomb" className="img-fluid BoombGif" />
                <div className="bombMainAni">
                  <img src={Boomb} alt="Boomb" className="img-fluid Boomb" />
                </div>
              </div>
            );
          default:
            return (
              <div className="cellImg">
                <div className="mainDimond">
                  <img src={CellImg} alt="Cell" className="img-fluid dimond rotate" />
                </div>
              </div>
            )
        }
      default:

    }

    // if (gameCellData?.minesNext?.active === 1 && gameCellData?.state?.rounds.indexOf(cellNumber) > -1) {
    //   return (
    //     <div className="cellImg">
    //       <div className="mainDimond">
    //         <img src={CellImg} alt="Cell" className="img-fluid dimond rotate" />
    //       </div>
    //     </div>
    //   )
    // }
    // if (gameCellData?.minesNext?.active === 0) {
    //   if (gameCellData?.state?.mines && gameCellData?.state?.mines.indexOf(cellNumber) > -1) {
    //     return (
    //       <div className="bombMain">
    //         <img src={BoombGif} alt="Bomb" className="img-fluid BoombGif" />
    //         <div className="bombMainAni">
    //           <img src={Boomb} alt="Boomb" className="img-fluid Boomb" />
    //         </div>
    //       </div>
    //     );
    //   } else {
    //     return (
    //       <div className="cellImg">
    //         <div className="mainDimond">
    //           <img src={CellImg} alt="Cell" className="img-fluid dimond rotate" />
    //         </div>
    //       </div>
    //     )
    //   }
    // }
  };


  return (
    // <div className={`board grid-${size}`}>
    //   {board.map((row, rowIndex) => (
    //     <div key={rowIndex} className="row justify-content-center align-items-center d-flex flex-nowrap">
    //       {row.map((cell, colIndex) => (
    //         <div
    //           key={colIndex}
    //           // style={{ width: 90 / size + '%' }}
    //           /////// autoSelect AutoSelectView ///////////
    //           className={`cell ${cell.isRevealed ? ' revealed' : ''}`}
    //           onClick={() => handleCellClick(rowIndex, colIndex)} // Trigger the audio on click
    //           data-revealed={cell.isRevealed}
    //         >
    //           {getCellContent(cell.isRevealed, cell.isBomb)}
    //         </div>
    //       ))}
    //     </div>
    //   ))}
    //   {gameOver &&
    //     <div className='winModelMain'>
    //       <div className="winModel">
    //         <div>
    //           <h1>2675.78 x</h1>
    //           <h4>$0.00 INR</h4>
    //         </div>
    //       </div>
    //     </div>
    //   }
    // </div>

    <div className={`board grid${size}`} style={{ display: "grid", gridTemplateColumns: `repeat(${size}, 1fr)` }}>
      {gridCell.length > 0 && gridCell.map((key, index) => (
        <div key={index} className="justify-content-center align-items-center">
          <div key={index}
            className={`grid${key?.cell} cell${gameCellData?.state?.rounds.indexOf(key?.cell) > -1 ? ' revealed' : (autoRoundActive?.indexOf(key?.cell) > -1 && Object.keys(gameData).length>0 ? ' AutoSelectView' : (autoRoundActive?.indexOf(key?.cell) > -1  ? ' autoSelect' : (gameCellData?.minesNext?.active === 0 ? ' hidden' : '')))} `} //${autoRoundActive?.indexOf(key?.cell) > -1 ? ' autoSelect' : ' hidden1'}
            onClick={Object.keys(gameData).length=== 0 || gameData?.minesNext?.active === 1 ? () => handleCellClick(key?.cell): undefined}
          >
            {/* cellAnimationClick */}
            {/* <p className='text-white'>{Object.keys(gameData).length}-- {gameCellData?.minesNext?.active}</p> */}
            {getCellContent(key?.cell)}
          </div>
        </div>
      ))}
      {isCashout &&
        <div className='winModelMain'>
          <div className="winModel">
            <div>
              <h1>({gameCellData?.minesNext?.payoutMultiplier}x)</h1>
              <h4>{gameCellData?.minesNext?.amountMultiplier} INR</h4>
            </div>
          </div>
        </div>
      }
    </div>
  );
};

export default Board;
